import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Film, Target, Search, Clock, Headphones, Sunrise } from "lucide-react";

const Item = ({ icon: Icon, title, children }) => (
  <div className="flex gap-3">
    <div className="mt-0.5 shrink-0 w-9 h-9 rounded-lg bg-amber-500/15 border border-amber-500/30 flex items-center justify-center">
      <Icon className="w-4 h-4 ac-gold-text" />
    </div>
    <div>
      <div className="font-semibold text-amber-100">{title}</div>
      <div className="text-sm text-zinc-400 leading-relaxed">{children}</div>
    </div>
  </div>
);

export const HowToPlayModal = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      data-testid="how-to-play-modal"
      className="ac-glass border-amber-500/25 text-zinc-100 max-w-lg max-h-[85vh] overflow-auto"
    >
      <DialogHeader>
        <DialogTitle className="font-display text-2xl font-black tracking-wider ac-gold-text text-center">
          HOW TO PLAY
        </DialogTitle>
      </DialogHeader>
      <div className="space-y-4 mt-2">
        <Item icon={Film} title="Daily Movie">
          One movie is selected for the day. Listen to the audio clue and guess it —
          everyone plays the same challenge.
        </Item>
        <Item icon={Target} title="Five Guesses">
          You get exactly five submitted guesses. Each wrong guess unlocks an easier
          audio clue.
        </Item>
        <Item icon={Search} title="Search">
          Type the movie name into the search box and select your answer. Searching never
          costs a guess — only pressing GUESS does.
        </Item>
        <Item icon={Clock} title="Time Machine">
          Replay any previous day's challenge. Results are tracked separately.
        </Item>
        <Item icon={Sunrise} title="Daily Reset">
          A brand new movie arrives every day at 12:00 AM IST.
        </Item>
      </div>
    </DialogContent>
  </Dialog>
);
